import { HttpAgentAdminService } from './../../../../service/http-agent.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgentDto } from '../../../../service/dto';

@Component({
	selector: 'app-agent-admin-view',
	standalone: false,
	templateUrl: './agent-admin-view.component.html',
	styleUrls: ['./agent-admin-view.component.scss']
})
export class AgentAdminViewComponent implements OnInit {
	agent?: AgentDto;
	loading = false;
	error?: string;

	constructor(
		private route: ActivatedRoute,
		private agentService: HttpAgentAdminService
	) { }

	ngOnInit(): void {
		const agentId = this.route.snapshot.paramMap.get('agentId');
		if (agentId) {
			this.loadAgent(+agentId);
		} else {
			this.error = 'No agent ID provided in route.';
		}
	}

	private loadAgent(id: number): void {
		this.loading = true;
		this.agentService.getFull(id).subscribe(result => {
			this.agent = result;
			this.loading = false;
		});
	}
}
